const STRIPE_LINKS = {
  pro: 'https://buy.stripe.com/00w4gAexu5cvcH48i28g000',
  free: 'https://buy.stripe.com/7sYbJ260YbAT36u7dY8g001'
};

export async function createCheckoutSession(priceId: string, userId: string, plan: string = 'pro') {
  try {
    // Append user ID as client_reference_id for tracking in webhooks
    const baseUrl = plan === 'founder' ? STRIPE_LINKS.pro : (STRIPE_LINKS[plan as keyof typeof STRIPE_LINKS] || STRIPE_LINKS.pro);
    const checkoutUrl = `${baseUrl}?client_reference_id=${userId}`;
    
    window.location.href = checkoutUrl;
  } catch (error) {
    console.error('Checkout error:', error);
    throw error;
  }
}

export async function createPortalSession(userId: string) {
  try {
    const response = await fetch('/api/create-portal-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId }),
    });

    const data = await response.json();
    if (data.url) {
      window.location.href = data.url;
    } else {
      throw new Error(data.error || 'Failed to create portal session');
    }
  } catch (error) {
    console.error('Portal error:', error);
    throw error;
  }
}
